import { useEffect, useState } from 'react';
import { Line } from 'react-chartjs-2'
import moment from 'moment'

import Base from '../../../../utils/base'
import CustomTable from '../../../../layout/custom_table/index'

export default function SalesRanking() {
  var base = new Base()
  const [arr, set_arr] = useState([])
  const [sort] = useState([
    {
      name: 'total_price',
      sort: 'desc',
    },
  ])
  const [arr_header, set_arr_header] = useState([
    {
      label: base.i18n.t('ranking'),
      data: 'ranking',
      style: {
        width: '10%',
      }
    },
    {
      label: base.i18n.t('product'),
      data: 'product_name',
    },
    {
      label: base.i18n.t('price'),
      data: 'total_price',
    },
  ])

  function on_update_data(arr){
    arr.forEach((data, index) => {
      data.total_price = data.currency.name + " " + data.total_price.toLocaleString(base.locale_string)
      data.product_name = data.name
      data.ranking = index + 1
    })
    set_arr(arr)
  }

  function on_download(){
    window.print()
  }

  return (
    <div className="card">
      <div className="card-body">
        <div className="d-print-none mb-3">
          <button className="btn btn-primary mr-3" onClick={() => on_download()}>{base.i18n.t('download')}</button>
        </div>
        <CustomTable
          url='/report/ranking/sales'
          include_sort={false}
          arr_header={arr_header}
          arr={arr}
          on_update_data={data => on_update_data(data)}/>
      </div>
    </div>
  );
}
